/**
 * Site desenvolvido para divulgação das especializações de odontologia
 *
 * @version 1.0.0
 * @author [Renato Alves](https://github.com/renatociqueira)
 */

import React from "react";
import './Header.css';
import { useHistory } from "react-router-dom";

const Header = () => {
    const History = useHistory();

    function Mostrarbarra() {

        let containerr = document.querySelector('.containerr');
    
            if(containerr.style.display === 'block') {
                containerr.style.display = 'none';
                } else {
                containerr.style.display = 'block';
            }
}

return (
    <>
    <div className="Header">
        <div className="logo" onClick={() => {History.push("/");}} >
        <img src="LOGO.png" className="desktoplogo" alt="logoposdesktop"></img>
        <img src="LOGO.png" className="mobilelogo" alt="logoposmobile" hidden></img>
                    {/* <h1 className="pos">PÓS</h1>
                        <h4 className="odonto">ODONTO</h4>
                        <h4 className="unifacex">UNIFACEX</h4> */}
        </div>
        <div>
            <a href='https://processoseletivo.unifacex.com.br/iniciar-inscricao' target="_blank" rel="noreferrer"><button className="pre-matricula" ><h3>INSCREVA-SE</h3></button></a>
        </div>
                <button id='btn-div'  onClick={(e) => { Mostrarbarra(e) }} className="Aside" ><img src="Menuprincipal.png" className="desktopmenu" alt="menuprincipal"></img></button>
                       
    </div>

        <aside className="barralateralll">
        {/* <button id='btn-div'  onClick={(e) => { Mostrarbarra(e) }} className="Aside-interno" ><img src="Menuinterno.png" className="desktopmenuinterno" alt="logopos"></img></button> */}
            <div className="containerr" id="barralaterall">
                <button id='btn-div'  onClick={(e) => { Mostrarbarra(e) }} className="Aside-interno" ><img src="Menuinterno.png" className="desktopmenuinterno" alt="menuinterno"></img></button>
                <br/><br/><img id="menu-endodontia" onClick={() => {History.push("/endodontia");}} src="Endodontia.png" className="desktopmenuendodontia" alt="menuendodontia"></img><br/><br/>
                            <img id="menu-imaginologia" onClick={() => {History.push("/imaginologia");}} src="Imaginologia.png" className="desktopmenuimaginologia" alt="menuimaginologia"></img><br/><br/>
                            <img id="menu-implantodontia" onClick={() => {History.push("/implantodontia");}} src="Implantodontia.png" className="desktopmenuimplantodontia" alt="menuimplantodontia"></img><br/><br/>
                            <img id="menu-pacientesespeciais" onClick={() => {History.push("/pacientesespeciais");}} src="Odontologia.png" className="desktopmenuodontologia" alt="menuodontologia"></img>
                            <img id="menu-line" src="Line.png" className="desktopmenuline" alt="logopos"></img>
                                <a href="http://unifacex.com.br/" target="_blank" rel="noreferrer"><img id="menu-conheca" src="conhecaunifacex.png" className="desktopconheca" alt="conhecaunifacex"></img></a>
                            <img id="menu-fale" src="faleconosco.png" className="desktofaleconosco" alt="logopos"></img>
            </div>
        </aside>
  </>
)

}

export default Header;